import React from "react";
import styles from "./skeleton.module.scss";
import clsx from "clsx";

const Skeleton = ({
  ariaLabel = "Loading interface...",
  variant = "rect",
  ...props
}) => {
  if (variant === "rect") {
    props.width = props.width || "100%";
    props.height = props.height || "100%";

    return (
      <div
        aria-disabled="true"
        aria-label={ariaLabel}
        style={{ ...props }}
        className={clsx(styles.rect, props.className)}
      />
    );
  }

  if (variant === "text") {
    props.height = props.height || "1rem";
    props.width = props.width || "100%";

    return (
      <div
        aria-disabled="true"
        aria-label={ariaLabel}
        style={{ ...props }}
        className={clsx(styles.text, props.className)}
      />
    );
  }

  throw new Error("Unknown variant");
};

export default Skeleton;
